import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { H2, H3 } from '../../components/typography';
import { useAPI } from '../../hooks/useAPI';
import { useTranslation } from 'react-i18next';
import Spacer from '../../components/Spacer';

const TenantConfirmation = () => {
  const { t } = useTranslation();
  const queryParameters = new URLSearchParams(window.location.search);
  const { tenantAcceptance, isLoading } = useAPI();
  const [isAccepted, setIsAccepted] = useState(null);

  useEffect(() => {
    const applicationId = queryParameters.get('application-id');
    const isAcceptedParam = queryParameters.get('is-accepted');
    (async () => {
      await tenantAcceptance({
        id: applicationId,
        tenantAccepted: isAcceptedParam === 'true'
      });
    })();
    setIsAccepted(isAcceptedParam === 'true');
  }, [queryParameters, tenantAcceptance]);

  return (
    <Box my={15} mx={2}>
      {isLoading && isAccepted === null && <CircularProgress />}
      {isAccepted ? (
        <H2 fontWeight="bold">{t('tenant_confirmation_accepted')}</H2>
      ) : (
        <Box>
          <H3>{t('tenant_confirmation_rejected')}</H3>
          <Spacer spacing={2} />
          <H3>{t('tenant_confirmation_rejected_2')}</H3>
          <Spacer spacing={2} />
          <H3>{t('tenant_confirmation_rejected_3')}</H3>
        </Box>
      )}
    </Box>
  );
};

export default TenantConfirmation;
